export default __webpack_public_path__ + "static/media/cuisine (1).e164e7ab.jpg";